import { Phone, CalendarCheck, Star, ArrowUpRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, BOOKING_URL, WRITE_REVIEW_URL } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-surface/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <a href="#top" className="flex items-center gap-3" data-testid="footer-logo" aria-label="SWS Auto Electrics & Air Conditioning — back to top">
          <img
            src="/sws-logo.webp"
            alt="SWS Auto Electrics & Air Conditioning logo"
            className="h-16 w-auto"
            width={200}
            height={64}
          />
        </a>
        <p className="mt-5 text-slate-400 text-[15px] leading-relaxed max-w-xs">
          Mobile auto electrical &amp; air conditioning, Sunshine Coast.
          Auto electrics done properly, at your place.
        </p>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-orange-500 font-semibold mb-5">
          Get it sorted
        </p>
        <ul className="space-y-4">
          <li>
            <a
              href={PHONE_TEL}
              data-testid="footer-call-link"
              className="inline-flex items-center gap-2.5 text-slate-200 hover:text-orange-400 transition-colors font-semibold"
            >
              <Phone size={16} className="text-orange-500" />
              {PHONE_DISPLAY}
            </a>
          </li>
          <li>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-link"
              className="inline-flex items-center gap-2.5 text-slate-200 hover:text-orange-400 transition-colors font-semibold"
            >
              <CalendarCheck size={16} className="text-orange-500" />
              Book online — ServiceM8
            </a>
          </li>
          <li>
            <a
              href={WRITE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-review-link"
              className="inline-flex items-center gap-2.5 text-slate-400 hover:text-orange-400 transition-colors"
            >
              <Star size={15} className="text-orange-500" />
              Leave a Google review
              <ArrowUpRight size={13} />
            </a>
          </li>
        </ul>
      </div>

      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-orange-500 font-semibold mb-5">
          Also coming
        </p>
        <p className="text-slate-400 text-[15px] leading-relaxed max-w-xs">
          <span className="text-slate-200 font-semibold">Roamwire</span> — our
          dedicated off-grid touring site. Solar, lithium, DC-DC, Starlink.
          Launching soon.
        </p>
      </div>
    </div>

    <div className="border-t border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          SWS Auto Electrics &amp; Air Conditioning — Sunshine Coast, QLD
        </p>
        <p
          data-testid="footer-licence"
          className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500"
        >
          Arctick refrigerant licence — AU54074
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          © {new Date().getFullYear()} — We come to you
        </p>
      </div>
    </div>
  </footer>
);
